import React from "react";
import { ButtonTertiary, Link, PromptConfirmation } from "ui";
import { toAbsoluteUrl } from "app/infrastructure/hosting";
import { routeConstants } from "app/routes/route-constants";
import { FailedDomainConstraintMetaData } from "app/types-shared";

interface WarningModalProps {
  title: string;
  description: string;
  continueText: string;
  cancelText?: string;
  onContinue: () => void;
  onCancel: () => void;
  warnings?: FailedDomainConstraintMetaData[];
  editCaseText?: string;
  caseId?: number;
  handleDropdownHide?: () => void;
  footerActionOverride?: React.ReactNode;
}

const WithWarningModal: React.FC<WarningModalProps> = ({
  title,
  description,
  continueText,
  cancelText,
  onContinue,
  onCancel,
  warnings,
  editCaseText,
  caseId,
  handleDropdownHide,
  footerActionOverride
}) => {
  const confirmMessages = warnings?.map((warning, index) => ({
    key: index,
    label: warning.domainText,
    message: warning.message
  }));

  return (
    <PromptConfirmation
      title={title}
      description={description}
      confirmMessages={confirmMessages}
      confirmationStyle="warning"
      continueText={continueText}
      onContinue={onContinue}
      closeOnDone={false}
      onCancel={onCancel}
      cancelText={cancelText}
      btnExtraFooterActionOverride={
        footerActionOverride && caseId && editCaseText && handleDropdownHide ? (
          <Link url={toAbsoluteUrl(routeConstants.caseEditFor(caseId))} target="_self">
            <ButtonTertiary onClick={handleDropdownHide}>{editCaseText}</ButtonTertiary>
          </Link>
        ) : null
      }
    />
  );
};

export const ConnectExistingWarningModal: React.FC<WarningModalProps> = (props) => (
  <WithWarningModal {...props} />
);

export const DisconnectWarningModal: React.FC<WarningModalProps> = (props) => (
  <WithWarningModal {...props} />
);
